var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgTrophy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.5H10V1C9.9997 0.734877 9.89424 0.4807 9.70677 0.293229C9.5193 0.105759 9.26512 0.000304367 9 0H3C2.73488 0.000304367 2.4807 0.105759 2.29323 0.293229C2.10576 0.4807 2.0003 0.734877 2 1V1.5H1C0.734877 1.5003 0.4807 1.60576 0.293229 1.79323C0.105759 1.9807 0.000304367 2.23488 0 2.5V4C0.000595527 4.53025 0.2115 5.03861 0.586444 5.41356C0.961388 5.7885 1.46975 5.9994 2 6H2.161C2.36934 6.76537 2.79603 7.45351 3.38897 7.9804C3.98191 8.50729 4.71545 8.85013 5.5 8.96705V11H3V12H9V11H6.5V8.96555C7.29474 8.86729 8.0414 8.53177 8.64257 8.00275C9.24373 7.47373 9.67148 6.77579 9.87 6H10C10.5303 5.9994 11.0386 5.7885 11.4136 5.41356C11.7885 5.03861 11.9994 4.53025 12 4V2.5C11.9997 2.23488 11.8942 1.9807 11.7068 1.79323C11.5193 1.60576 11.2651 1.5003 11 1.5ZM2 5C1.73488 4.9997 1.4807 4.89424 1.29323 4.70677C1.10576 4.5193 1.0003 4.26512 1 4V2.5H2V5ZM9 5C9 5.40177 8.91929 5.79945 8.76268 6.16944C8.60606 6.53942 8.37672 6.87418 8.08827 7.15385C7.79981 7.43352 7.45812 7.6524 7.08347 7.7975C6.70881 7.9426 6.30883 8.01097 5.90725 7.99855C5.11101 7.94917 4.36447 7.59467 3.82296 7.00883C3.28146 6.42299 2.98669 5.65091 3 4.85325V1H9V5ZM11 4C10.9997 4.26512 10.8942 4.5193 10.7068 4.70677C10.5193 4.89424 10.2651 4.9997 10 5V2.5H11V4Z",
    fill: "inherit"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgTrophy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trophy.229e0dad58e91261a1cd2b551cf9e038.svg";